module.exports = __webpack_public_path__ + "images/arrow_up_8a6b9dbf10215488786060323692737b.svg";